<template>
  <div class="text-center md:text-left leading-[1.75rem]">
    <p
      class="text-base leading-normal mb-2 font-bold uppercase text-mouse"
      role="heading"
      aria-level="2"
    >
      {{ $t('meta/support') }}
    </p>
    <nuxt-link
      :to="supportLink"
      class="text-mouse no-underline hover:text-white transition-colors block md:mt-4"
      >{{ $t('general/menu/block/ticket_system') }}
    </nuxt-link>
  </div>
</template>

<script setup lang="ts">
const { locale } = useI18n();

const supportLink = computed<string>(() => `/${locale.value}/support`);
</script>
